
/**
 * Internal dependencies
 */
import {
    UNIVERSALIMPORTER_PLANS_RECEIVE,
    UNIVERSALIMPORTER_PLANS_REQUEST,
    UNIVERSALIMPORTER_PLANS_REQUEST_SUCCESS,
    UNIVERSALIMPORTER_PLANS_REQUEST_FAILURE,
} from 'state/action-types';

import cscom from 'lib/customer-site-api';
import { getAllUniversalImporterPlans, requestingUniversalImporterPlans } from './selectors';

/**
 * [description]
 * 
 * @param  {Function} includeSupport [description]
 * @return {[type]}                  [description]
 */
export const requestUniversalImporterPlans = () => (dispatch) => {
    dispatch({
        type: UNIVERSALIMPORTER_PLANS_REQUEST
    });
    return cscom
        .universalImporterPlan()
        .list()
        .then(universalImporterPlans => {
            dispatch({ type: UNIVERSALIMPORTER_PLANS_REQUEST_SUCCESS });
            dispatch({ type: UNIVERSALIMPORTER_PLANS_RECEIVE, payload: { items: universalImporterPlans } });
            return universalImporterPlans;
        })
        .catch((error) => {
            dispatch({ type: UNIVERSALIMPORTER_PLANS_REQUEST_FAILURE, error });
        });
}

/**
 * [description]
 * 
 * @param  {...[type]} props) [description]
 * @return {[type]}           [description]
 */
export const requestPlansIfNotRequested = (...props) => async (dispatch, getState) => {
	
	const plans = getAllUniversalImporterPlans(getState());
	const requesting = requestingUniversalImporterPlans(getState());

	if (plans.length == 0 && requesting == false) {
		return dispatch(requestUniversalImporterPlans(...props))
	}

	return plans;
}